import { writable } from 'svelte/store'
import type { DeviceFilterState } from './devices'

export interface UserSettings {
  logDisplayCount: number
  logLoadMoreCount: number
  timezone: string
  deviceLogAutoRefresh: boolean
  deviceLogRefreshInterval: number
  deviceFilter?: DeviceFilterState
}

export const defaultUserSettings: UserSettings = {
  logDisplayCount: 20,
  logLoadMoreCount: 20,
  timezone: 'Europe/Oslo',
  deviceLogAutoRefresh: true,
  deviceLogRefreshInterval: 5000
}

export const userSettings = writable<UserSettings>(defaultUserSettings)

const settingsKey = 'sdm.settings'

export function readStoredSettings(): any {
  try {
    const raw = localStorage.getItem(settingsKey)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

export function patchStoredSettings(patch: Record<string, any>): any {
  const current = readStoredSettings() || {}
  const next = { ...current, ...patch }
  if (patch.browserStates) {
    next.browserStates = { ...(current.browserStates || {}), ...patch.browserStates }
  }
  localStorage.setItem(settingsKey, JSON.stringify(next))
  return next
}

export function loadUserSettings(settings: any) {
  if (!settings) {
    userSettings.set(defaultUserSettings)
    return
  }

  userSettings.set({
    logDisplayCount: settings.logDisplayCount || defaultUserSettings.logDisplayCount,
    logLoadMoreCount: settings.logLoadMoreCount || defaultUserSettings.logLoadMoreCount,
    timezone: settings.timezone || defaultUserSettings.timezone,
    deviceLogAutoRefresh: settings.deviceLogAutoRefresh ?? defaultUserSettings.deviceLogAutoRefresh,
    deviceLogRefreshInterval: settings.deviceLogRefreshInterval || defaultUserSettings.deviceLogRefreshInterval,
    deviceFilter: settings.deviceFilter
  })
}